const postStreamFactory = require('../lib/stream/post-stream-factory')
const postStreamFunctions = require('../lib/stream/post-stream-functions')
const streamFactory = require('../lib/stream/stream-factory')
const streamFunctions = require('../lib/stream/stream-functions')

module.exports = postStreamFactory(streamFactory({
  add: streamFunctions.addUnique,
  addAll: streamFunctions.addAll,
  removeById: streamFunctions.removeById,
  update: streamFunctions.updateById,
  deleteAll: streamFunctions.removeAllById,
}), {
  sorted: postStreamFunctions.sortByName,
})
